import React, { Fragment, useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.svg';
import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';
import calConfig from '../../config/calConfig';
import './AsesoriaPage.scss';

const AsesoriaPage = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: calConfig.namespace });
      cal('ui', { hideEventTypeDetails: false, layout: 'month_view' });
    })();
  }, []);

  return (
    <Fragment>
      <SEO {...getRouteMeta('/asesoria')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />
      <PageTitle
        pageTitle={'Reserva tu Asesoría Jurídica'}
        pagesub={'Asesoría'}
      />

      <div className="asesoria-page">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="asesoria-header">
                <p className="subtitle">
                  Selecciona la fecha y hora que mejor se adapte a tu
                  disponibilidad. Una vez confirmada tu cita, serás redirigido
                  automáticamente al portal de pago seguro.
                </p>
              </div>

              <div className="cal-embed-wrapper">
                <Cal
                  namespace={calConfig.namespace}
                  calLink={calConfig.calLink}
                  style={{ width: '100%', height: '700px', overflow: 'scroll' }}
                  config={{ layout: 'month_view' }}
                />
              </div>

              <div className="asesoria-info">
                <div className="info-card">
                  <div className="info-icon">💳</div>
                  <div className="info-content">
                    <h3>Pago Seguro</h3>
                    <p>
                      Al confirmar tu cita, serás redirigido automáticamente al
                      portal de pago seguro de Flow. El valor de la asesoría es
                      de <strong>$50.000 CLP</strong>.
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">📅</div>
                  <div className="info-content">
                    <h3>Confirmación Inmediata</h3>
                    <p>
                      Una vez completado el pago, tu reserva será confirmada
                      automáticamente y recibirás un correo con todos los
                      detalles de tu cita.
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">🔒</div>
                  <div className="info-content">
                    <h3>Datos Protegidos</h3>
                    <p>
                      Todos tus datos están protegidos y encriptados. Utilizamos
                      los más altos estándares de seguridad para proteger tu
                      información.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default AsesoriaPage;
